import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "user",
  "use": "user-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"user\"><title>icn/user</title><path d=\"M7.5 7a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm.5 7c-5.924 0-6-.669-6-2.16S2.964 8 8 8s6 2.307 6 3.84S13.924 14 8 14z\" id=\"user_a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol